export default __webpack_public_path__ + "9353cd51ba6ff2a953ecaff348e4901a.svg";